import router from '@/router'
import type { RouteParamsRawGeneric, RouteRecordName } from 'vue-router'

export const capitalize = (word: string) => {
    return word.charAt(0).toUpperCase() + word.slice(1)
}

export const chunkArray = (arr: Array<any> | undefined, size: number) => {
    if (!arr) return []
    const chunked = []
    for (let index = 0; index < arr.length; index += size) {
        chunked.push(arr.slice(index, index + size))
    }
    return chunked
}

const pad = (n: number): string => String(n).padStart(2, '0')

/**
 * Parse a date value from the API (or a form) into a local Date, or null.
 *
 * - 'YYYY-MM-DD' (date-only columns such as date_of_birth) is built from its
 *   parts in local time. new Date('YYYY-MM-DD') parses it as UTC midnight,
 *   which shows as the previous day on devices west of UTC.
 * - 'DD/MM/YYYY' (UK form input) is built from its parts. new Date() would
 *   read it as MM/DD/YYYY.
 * - Anything else (ISO datetimes such as completed_at) goes through Date.
 */
export const parseDate = (value: string | null | undefined): Date | null => {
    if (!value) return null

    const isoDate = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
    const ukDate = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value)
    let date: Date
    if (isoDate) {
        date = new Date(Number(isoDate[1]), Number(isoDate[2]) - 1, Number(isoDate[3]))
    } else if (ukDate) {
        date = new Date(Number(ukDate[3]), Number(ukDate[2]) - 1, Number(ukDate[1]))
    } else {
        date = new Date(value)
    }

    return isNaN(date.getTime()) ? null : date
}

/**
 * Format a date as DD/MM/YYYY regardless of the device locale.
 * Returns '' for a missing or unparseable value.
 */
export const formatDate = (value: string | null | undefined): string => {
    const date = parseDate(value)
    if (!date) return ''

    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`
}

export const navigateToPage = async (routeName: RouteRecordName, params?: RouteParamsRawGeneric): Promise<void> => {
    await router.push({ name: routeName, params })
}
